module.exports = __webpack_public_path__ + "img/wm-rt.64ffd39a.png";